import { ReservationField } from '@cheqroom/api';
import { Settings } from '@cheqroom/icons';
import { Button } from '@cheqroom/ui';
import useModal from '@cheqroom/ui/hooks/useModal';
import { FC } from 'react';

import { CustomField, Field, SystemField, SystemFieldType as ItemSystemFieldType } from '../../hooks/item-fields/types';
import useItemFieldsConfig from '../../hooks/item-fields/use-item-fields-config';
import CustomizeItemsOverviewModal, { Props as CustomizeOverviewModalProps } from './CustomizeOverviewModal';

type Props = {
	type: 'items-list' | 'check-outs-list' | 'contacts-list' | 'kits-list' | 'reservations-list' | 'spotchecks-list';
	viewType: 'table' | 'cards' | 'scheduler';
	itemTypeId?: string;
	selectedColumns: string[];
	saveSelectedColumns: (selectedColumns: string[]) => void;
} & (
	| {
			type: 'items-list';
			fields: Field<ItemSystemFieldType>[];
	  }
	| {
			type: 'reservations-list';
			fields: Field<ReservationField>[];
	  }
	| {
			type: 'check-outs-list' | 'contacts-list' | 'kits-list' | 'spotchecks-list';
			fields: Field<string>[];
	  }
);
const CustomizeOverview: FC<Props> = ({ type, viewType, itemTypeId, fields, selectedColumns, saveSelectedColumns }) => {
	const [showModal] = useModal<CustomizeOverviewModalProps>((props) => <CustomizeItemsOverviewModal {...props} />);

	const customFields = fields.filter((field) => field.id.startsWith('fields.')) as CustomField[];
	const systemFields = fields.filter((field) => !field.id.startsWith('fields.')) as SystemField<any>[];

	const [initialSelectedFieldIds, saveSelectedFieldIds] = useItemFieldsConfig(itemTypeId);

	const handleSaveConfig = (selectedColumns: string[], selectedFields?: string[]) => {
		saveSelectedColumns(selectedColumns);

		if (selectedFields) {
			saveSelectedFieldIds(selectedFields);
		}
	};

	const handleShowModalClick = () => {
		showModal({
			type,
			viewType,
			customFields,
			systemFields,
			selectedColumns,
			saveConfig: handleSaveConfig,
			selectedFields: initialSelectedFieldIds,
		});
	};

	return (
		<Button variation="secondary" leftIcon={Settings} onClick={handleShowModalClick}>
			Customize overview
		</Button>
	);
};

export default CustomizeOverview;
